
import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface ErrorDisplayProps {
  error: Error | string | null;
  onRetry?: () => void;
}

export const ErrorDisplay = ({ error, onRetry }: ErrorDisplayProps) => {
  // Convert any error type to string for display
  const errorMessage = typeof error === 'string' 
    ? error 
    : error instanceof Error
      ? error.message
      : "An unknown error occurred";
  
  return (
    <div className="flex items-center justify-center min-h-[400px] px-4">
      <Card className="max-w-md w-full p-6 text-center shadow-lg border-red-200">
        <div className="flex justify-center mb-4">
          <AlertTriangle className="h-12 w-12 text-destructive" />
        </div>
        <h3 className="text-xl font-medium mb-2">Something went wrong</h3>
        <p className="text-muted-foreground mb-6">{errorMessage}</p>
        {onRetry && (
          <Button onClick={onRetry} variant="outline" className="mx-auto">
            Try Again
          </Button>
        )}
      </Card>
    </div>
  );
};
